import React, {useState} from "react"
import { useFormik } from 'formik';
import {graphql} from "gatsby"
import Layout from "../components/layout"
import opening from "./opening.png"

// A custom validation function. This must return an object
// which keys are symmetrical to our values/initialValues
const validate = values => {
    console.debug(`validate length: ${values}`)
    console.debug(values)
    const errors = {};
    if (!values.plz) {
        errors.plz = 'Required';
    } else if (values.plz.toString().length !== 5) {
        errors.plz = 'Must be 5 characters';
    }
    return errors;
};

const MyDayForFuture = ({location}) => {
    let nextDay = new Date()
    nextDay.setDate(nextDay.getDate() + 1)
    const date = nextDay.toLocaleDateString("de-DE")
    console.log(date)

    const [plz, setPlz] = useState();

    // Pass the useFormik() hook initial form values and a submit function that will
    // be called when the form is submitted
    const formik = useFormik({
        initialValues: {
            plz: '',
        },
        validate,
        onSubmit: values => {
            // alert(JSON.stringify(values, null, 2));
            console.debug(values)
            setPlz(values)
        },
    });

    return (
        <Layout location={location}>

            <p>
                Boy Scout Principle: Jeden Tag eine gute Tat, hinterlasse den Ort ein bisschen besser als er vorher war.
            </p>
            <p> Rücksicht ist wichtig! </p>

            {/*<div>Aktuelle Daten sind für: {date}</div>*/}
            {/*<p> Gib deine PLZ ein:</p>*/}

            {/*<form onSubmit={formik.handleSubmit}>*/}
            {/*    /!*<label htmlFor="plz">PLZ</label>*!/*/}
            {/*    <input*/}
            {/*        id="plz"*/}
            {/*        name="plz"*/}
            {/*        type="number"*/}
            {/*        minLength={5}*/}
            {/*        required*/}
            {/*        onChange={formik.handleChange}*/}
            {/*        value={formik.values.plz}*/}
            {/*        onBlur={formik.handleBlur}*/}
            {/*        style={{textAlign: 'center'}}*/}
            {/*    />*/}
            {/*    {formik.touched.plz && formik.errors.plz ? ( <div>{formik.errors.plz}</div> ) : null}*/}
            {/*    <button type="submit">Submit</button>*/}
            {/*</form>*/}

            {/*{plz && <img src={opening} alt=""/>}*/}
        </Layout>
    )
}

export default MyDayForFuture

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
